export const tagOptions = [
  { label: "Learning from THE MANUAL", color: "#00D1FF" },
  { label: "Ranked", color: "#6BFF8D" },
  { label: "Scrim", color: "#FF6B6B" },
  { label: "Vod Review", color: "#6B9EFF" },
  { label: "Dry Runs", color: "#FFD166" },
  { label: "Premier", color: "#B16BFF" },
  { label: "Game Day", color: "#FFB347" },
  { label: "Coaching Session", color: "#59D9BB" },
  { label: "Watch Party", color: "#FF70C5" },
  { label: "Tentative Session", color: "#A6B85D" },
  { label: "Other", color: "#CCCCCC" }
];

export const getEventTagColor = tag => tagOptions.find(option => option.label === tag)?.color || "#CCCCCC";
